export const RETURN_EXCHANGE_POLICY = [
  'Returns allowed for 7 days on all non-perishable products.',
  'Perishable items such as fruits, vegetables, fresh meat and dairy products are not eligible for returns.',
  'No exchange is allowed on orders.',
];
